// Service
import authenticateService from '@/app/services/main/authenticate/authenticate-service.js';

// Util
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Constants
import { STATUS_CODES } from '@/app/constants/constants.js';

// Date-Fns helpers
import { addMonths, formatISO } from 'date-fns';

export default {
    name: 'AuthPassword',
    data() {
        return {
            isAPILoading: false,
            pinCode: ''
        }
    },
    computed: {
        validationRules() {
			let fields = {
				pinCode: {}
			};
			fields = vuelidateUtil.setFieldsRequired(fields, true);
			return fields;
		},
		authStatus() {
			return this.$store.getters.getAuthMessage;
		}
    },
    methods: {
        onSubmit() {
			this.isAPILoading = true;

			const pinDetails = {
				pinCode: this.pinCode
			};

			this.commitAuthMessage('', '');

			// validate pin code api
			authenticateService.validatePinCode(pinDetails)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.isAPILoading = false;
						
						// save pin code
                        this.$store.commit('setPinCode', pinDetails.pinCode);

                        // update authentication status on store
                        this.$store.commit('setUserAuthentication', true);
                        this.$store.dispatch('initializeUnauthenticateTimer');

                        // set auth expiry date
                        const expiryDate = addMonths(new Date(), 1);
                        this.$store.commit('setAuthExpiry', formatISO(expiryDate));

                        // redirect to login
                        if (this.$store.getters.getAuthExpiry) {
                            this.$router.push('/login');
                        }
					} else {
						this.isAPILoading = false;
						this.commitAuthMessage('failed', res.data.errors);
					}
				});
        },
		commitAuthMessage(status, message) {
			this.$store.commit('setAuthMessage', {status, message});
		}
    },
	validations() {
		return this.validationRules;
	}
}